import { useEffect } from 'react';
import { desktop } from '../lib/desktop';
import { useTeamChatUnread } from './useTeamChat';

/**
 * The unread team-chat count on the desktop app's icon (Dock number on macOS,
 * a red dot on the Windows taskbar). Reuses the poll the sidebar badge already
 * runs. Mounted once, in the app shell (Layout); cleared when it unmounts
 * (signing out). Does nothing in a browser.
 */
export function useDesktopBadge(): void {
  const { data } = useTeamChatUnread();
  const total = data?.total ?? 0;

  useEffect(() => {
    desktop()?.setBadge(total);
  }, [total]);

  useEffect(() => () => desktop()?.setBadge(0), []);
}
